module.exports = __webpack_public_path__ + "static/media/8@1280w.0c8501b3.jpg";